export const MAX_ROOM_NAME_LENGTH = 25
